module.exports = __webpack_public_path__ + "static/media/uomo.8bbd9e19.png";